import React, { useState } from 'react'
import { useRetorikStore } from '../../Contexts/RetorikContext'
import { useSpeechStore } from '../../Contexts/SpeechContext'

import { Mode, RecognitionState } from '../../../models/enums'

import SendTextBox from '../../AnswerPanel/SendTextBox'
import ModeButton from './ModeButton'
import { MicrophoneButton } from '../Common'
import VoiceInput from '../../AnswerPanel/OldVoiceInput'

interface MobileProps {
  parametersOpened: boolean
  toggleParameters: () => void
}

const Mobile = ({ parametersOpened, toggleParameters }: MobileProps): JSX.Element => {
  const hideMenu = useRetorikStore((state) => state.configuration.hideMenu)
  const disabledSpeechMode = useRetorikStore((state) => state.configuration.disableSpeechMode)
  const mode = useSpeechStore((state) => state.mode)
  const appAvailable = useRetorikStore((state) => state.appAvailable)
  const { setActiveRecognitionState, setMode } = useSpeechStore((state) => state.actions)
  const setCanFocusSendBox = useRetorikStore((state) => state.actions.setCanFocusSendBox)

  const [fromTextToVocal, setFromTextToVocal] = useState<boolean>(false)

  const toggleMode = (newMode: number): void => {
    // If the parameters are opened, no action
    if (!parametersOpened) {
      setFromTextToVocal(true)
      if (newMode === Mode.text) {
        setCanFocusSendBox(true)
        setActiveRecognitionState(RecognitionState.ForceClosing)
      }
      setMode(newMode)
    }
  }

  const handleDashboardClick = (): void => {
    toggleParameters()
  }

  return (
    <div
      id='retorik-framework-menu'
      className='rf-w-full rf-h-fit rf-max-h-80 rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto'
      style={{
        background: 'linear-gradient(to right, #F8F8FC, #EDEEF3)'
      }}
    >
      {/* Main buttons : text / vocal / parameters */}
      <div
        className={`rf-w-full rf-grid rf-flex-1 rf-h-full ${
          !disabledSpeechMode ? (hideMenu ? 'rf-grid-cols-2' : 'rf-grid-cols-3') : hideMenu ? 'rf-grid-cols-1' : 'rf-grid-cols-2'
        } rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`}
      >
        {/* Text */}
        <ModeButton label='text' selected={parametersOpened ? false : mode === Mode.text} onClick={toggleMode} />

        {/* Vocal / Microphone */}
        {!disabledSpeechMode &&
          (mode === Mode.vocal ? (
            <div className='rf-py-2 rf-w-full rf-flex rf-justify-center'>
              <MicrophoneButton openMicrophone={fromTextToVocal} />
            </div>
          ) : (
            <ModeButton label='vocal' selected={false} onClick={toggleMode} />
          ))}

        {/* Parameters */}
        {!hideMenu && <ModeButton label='dashboard' selected={parametersOpened} onClick={handleDashboardClick} />}
      </div>

      {/* Input textbox */}
      {!parametersOpened && mode === Mode.text && <SendTextBox className='rf-mx-4 rf-mt-2' />}

      {/* Speech interims */}
      {appAvailable && !parametersOpened && mode === Mode.vocal && <VoiceInput className='rf-w-full rf-px-6 rf-py-2' />}
    </div>
  )
}

export default Mobile
